const data = {
    contact: {
        name: '',
        location: {
            lat: '',
            lon: '',
            words: ''
        },
        email: '',
        address: '',
        phone: ''
    },
    item: {
        id: '',
        item: '',
        categoryId: '',
        measurement: '',
        units: ''
    },
    inventoryItem: {
        id: '',
        units: '',
        price: '',
        currency: '',
        supplier: ''
    },
    translation: {
        id: '',
        lang: '',
        group: '',
        word: '',
        translation: ''
    }
}

export default data
